<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <img class="mr-2" :src="require(`@/assets/appIcon-apps--CustomerBase.svg`)" width="18">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
            <router-link :to="{name: 'BaseList'}" class="subtitle-1 routerLink font-weight-medium">Customer Base</router-link>
            <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>

            <v-skeleton-loader class="mt-2 d-inline-block" v-if="$store.state.apps.retrieveLoader" type="text" width="200" />
            <v-text-field class="d-inline-block" v-model="$v.base.name.$model" :error="$v.base.name.$error" maxlength="56" outlined single-line dense background-color="white" hide-details>
              <template v-slot:append>
                <v-tooltip right max-width="280px" transition="scale-transition">
                  <template v-slot:activator="{ on }">
                    <v-icon class="mr-2 mt-0" v-on="on" size="20" color="secondary">mdi-information</v-icon>
                  </template>
                  <span>Un nombre único e interno que te ayude a identificar este portal de cliente dentro de tu organización.</span>
                </v-tooltip>
              </template>
            </v-text-field>
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="py-0 background" style="height: calc(100vh - 225px); overflow-y: auto;">
          <v-row class="fill-height">
            <v-col cols="4" class="px-0 fill-height overflow-y-auto" v-if="$store.state.apps.retrieveLoader">
              <v-skeleton-loader class="transparent" type="list-item-three-line, list-item-three-line" />
            </v-col>
            <v-col cols="4" class="px-0 fill-height overflow-y-auto" v-else>
              <!-- features -->
              <v-list class="transparent">
                <v-list-item class="py-2">
                  <v-list-item-title class="body-2 text--secondary font-weight-medium">Funcionalidades</v-list-item-title>
                </v-list-item>
                <v-list-item class="py-2">
                  <v-list-item-title>Administrar información de facturación</v-list-item-title>
                  <v-list-item-action>
                    <v-switch class="mt-n3 ml-n6" v-model="base.manage_billing" style="position: absolute" />
                  </v-list-item-action>
                </v-list-item>
                <v-list-item class="py-2">
                  <v-list-item-title>Cancelar suscripción</v-list-item-title>
                  <v-list-item-action>
                    <v-switch class="mt-n3 ml-n6" v-model="base.cancel_subscription" style="position: absolute" />
                  </v-list-item-action>
                </v-list-item>
                <v-list-item class="py-2">
                  <v-list-item-title>Administrar tarjeta</v-list-item-title>
                  <v-list-item-action>
                    <v-switch class="mt-n3 ml-n6" v-model="base.manage_source" style="position: absolute" />
                  </v-list-item-action>
                </v-list-item>
                <v-list-item class="py-2">
                  <v-list-item-title>Visualizar facturación y pagos</v-list-item-title>
                  <v-list-item-action>
                    <v-switch class="mt-n3 ml-n6" v-model="base.display_invoices" style="position: absolute" />
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <!-- end features -->

              <!-- authentication -->
              <v-list class="mt-6 transparent">
                <v-list-item class="py-2">
                  <v-list-item-title class="body-2 text--secondary font-weight-medium">Método de autenticación</v-list-item-title>
                </v-list-item>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-radio-group class="my-0" v-model="base.auth_scheme" hide-details>
                        <v-radio class="mb-2" value="email">
                          <template v-slot:label>
                            Autenticación con email a través de Piriod
                            <v-menu open-on-hover offset-x right nudge-top="40" max-width="280px" transition="scale-transition">
                              <template v-slot:activator="{ on }">
                                <v-icon class="ml-2" v-on="on" small color="secondary">mdi-information</v-icon>
                              </template>
                              <v-sheet class="py-2 px-3">
                                <span class="d-block my-1 body-2">Permite a tu cliente solicitar un enlace de acceso usando su correo electrónico.</span>
                                <v-btn :href="`${$DOCS_BASE}/docs/apps-customer_base#4-autenticacion-usando-email`" target="_blank" color="primary" text>Aprende más<v-icon right small>mdi-arrow-right</v-icon></v-btn>
                              </v-sheet>
                            </v-menu>
                          </template>
                        </v-radio>
                        <v-radio class="mt-2" value="existing">
                          <template v-slot:label>
                            Integrar con una autenticación existente
                            <v-menu open-on-hover offset-x right nudge-top="50" max-width="280px" transition="scale-transition">
                              <template v-slot:activator="{ on }">
                                <v-icon class="ml-2" v-on="on" small color="secondary">mdi-information</v-icon>
                              </template>
                              <v-sheet class="py-2 px-3">
                                <span class="d-block my-1 body-2">Crea una sesión única para identificar a tu cliente desde tu backend usando la API.</span>
                                <v-btn :href="`${$DOCS_BASE}/docs/apps-customer_base#3-crear-una-sesión-para-tu-cliente`" target="_blank" color="primary" text>Aprende más<v-icon right small>mdi-arrow-right</v-icon></v-btn>
                              </v-sheet>
                            </v-menu>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="py-2" v-if="base.auth_scheme === 'email'">
                  <v-list-item-content>
                    <v-list-item-title>
                      Redireccionamiento por defecto
                      <v-tooltip right max-width="280px" transition="scale-transition">
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                        </template>
                        <span class="text--primary">El cliente será redireccionado a esta URL cuando la sesión quede obsoleta.</span>
                      </v-tooltip>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <v-text-field v-model.trim="$v.base.return_url.$model" :error="$v.base.return_url.$error" background-color="white" outlined required single-line dense autocomplete="off" maxlength="64" persistent-hint hide-details placeholder="https://myproduct.com/account" />
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <!-- end authentication -->
            </v-col>
            <v-divider vertical />
            <v-col class="fill-height overflow-y-auto">
              <v-skeleton-loader class="transparent" v-if="$store.state.apps.retrieveLoader" type="list-item-three-line, list-item-three-line, list-item-three-line" />

              <template v-else>
                <v-row class="px-6" align="center" justify="space-between">
                  <v-btn-toggle v-if="base.auth_scheme === 'email'" v-model="portalDemoView" color="primary" dense>
                    <v-btn outlined :ripple="false" small value="signin">Inicio de sesión</v-btn>
                    <v-btn outlined :ripple="false" small value="main">Pagina principal</v-btn>
                  </v-btn-toggle>
                  <v-spacer />
                  <v-btn-toggle v-model="portalDemoSize" color="primary" dense>
                    <v-btn outlined icon :ripple="false" :value="350"><v-icon color="primary">mdi-cellphone-screenshot</v-icon></v-btn>
                    <v-btn outlined icon :ripple="false" :value="700"><v-icon color="primary">mdi-monitor-screenshot</v-icon></v-btn>
                  </v-btn-toggle>
                </v-row>
                <portal-demo :view="portalDemoView" :size="portalDemoSize" :cancelSubscription="base.cancel_subscription" :displayInvoices="base.display_invoices" :manageSource="base.manage_source" :manageBilling="base.manage_billing" />
              </template>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="py-0 px-4">
          <v-row align="center">
            <v-col cols="4">
              <v-row no-gutters>
                <v-spacer />
                <v-btn v-if="$route.name === 'BaseCreate'" @click="createBase" :loading="$store.state.apps.createLoader" color="primary" :ripple="false">Crear y poner en vivo</v-btn>
                <v-btn v-else-if="$route.name === 'BaseUpdate'" @click="updateBase" :loading="$store.state.apps.createLoader" color="primary" :ripple="false">Guardar cambios</v-btn>
              </v-row>
            </v-col>
            <v-divider vertical />
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { maxLength, required, url } from 'vuelidate/lib/validators'
import { cloneDeep } from 'lodash'

import GenericViewMixin from '@/mixins/GenericViewMixin'

import PortalDemo from '@/components/customer-base/PortalDemo'

export default {
  mixins: [
    GenericViewMixin
  ],
  components: {
    PortalDemo
  },
  data: () => ({
    base: {
      auth_scheme: 'email',
      cancel_subscription: true,
      display_invoices: true,
      manage_billing: true,
      manage_source: true,
      name: 'Nuevo portal de cliente',
      return_url: ''
    },
    portalDemoView: 'main',
    portalDemoSize: 700,
    step: 1
  }),
  computed: mapState({
    instance: state => state.apps.basesDetail
  }),
  created () {
    /**
     * Retrieve Base object from API if view
     * action is update
     */
    if (this.$route.name === 'BaseUpdate') {
      this.$store.dispatch('apps/RETRIEVE', {
        resource: 'customer_base/bases',
        id: this.$route.params.id
      })
      .then(() => {
        const clone = cloneDeep(this.instance)

        Object.keys(this.base).forEach(k => {
          this.base[k] = clone[k]
        })
      })
    }
  },
  watch: {
    'base.auth_scheme' () {
      this.portalDemoView = this.base.auth_scheme === 'email' ? 'signin' : 'main'
    },
    'base.cancel_subscription' () {
      this.portalDemoView = 'main'
    },
    'base.display_invoices' () {
      this.portalDemoView = 'main'
    },
    'base.manage_source' () {
      this.portalDemoView = 'main'
    },
    'base.manage_billing' () {
      this.portalDemoView = 'main'
    }
  },
  methods: {
    createBase () {
      this.$v.base.$touch()

      if (this.$v.base.$invalid) {
        return false
      }

      this.$store.dispatch('apps/CREATE', {
        resource: 'customer_base/bases',
        payload: this.base
      })
      .then((response) => {
        this.$router.push({
          name: 'BaseRetrieve',
          params: {
            id: response.data.id
          },
          query: {
            ref: 'setup'
          }
        })
        this.$dialog.message.info('Se ha creado el nuevo portal de cliente.')
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    },
    updateBase () {
      this.$v.base.$touch()

      if (this.$v.base.$invalid) {
        return false
      }

      this.$store.dispatch('apps/UPDATE', {
        resource: 'customer_base/bases',
        id: this.instance.id,
        payload: this.base
      })
      .then(() => {
        this.$router.push({
          name: 'BaseRetrieve',
          params: {
            id: this.instance.id
          },
          query: {
            ref: 'setup'
          }
        })
        this.$dialog.message.info('Los cambios del portal de cliente han sido guardados.')
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    }
  },
  validations: {
    base: {
      name: {
        required
      },
      return_url: {
        url,
        maxLength: maxLength(64)
      }
    }
  }
}
</script>